import { APP_CONSTANTS } from "../../constants/AppConstants";
import { httpApi } from "./http.api";

interface UserDetails {
  email: string;
  ecom_id: string;
}

interface DesignView {
  viewId: number;
  designImage: string; // base64 encoded image
  designJson: object;
  designSvg: string;
  printMethodId: number;
}

interface DesignData {
  unique_id?: string;
  user_details: UserDetails;
  design_name: string;
  design_views: DesignView[];
}

interface SaveDesignParams {
  productId: string;
  variantId?: string | null;
  designType?: number;
  designData: DesignData;
}

export const saveDesign = (
  productId: string,
  designData: SaveDesignParams
): Promise<any> => {
  return new Promise((resolve) => {
    httpApi
      .post("/front/save-design/" + productId, { ...designData })
      .then(({ data }) => {
        resolve(data);
      });
  });
};

export const saveDesignName = (
  designId: string,
  designData: any
): Promise<any> => {
  return new Promise((resolve) => {
    httpApi
      .post("/front-design/update-design-name/" + designId, { ...designData })
      .then(({ data }) => {
        resolve(data);
      });
  });
};

export const getSavedDesign = (userId: string): Promise<any> => {
  return new Promise((resolve) => {
    httpApi.get("/front/save-design/" + userId).then(({ data }) => {
      resolve(data);
    });
  });
};

export const getUserInfo = (userId: string): Promise<any> => {
  return new Promise((resolve) => {
    httpApi.get("/front/get-user-info/" + userId).then(({ data }) => {
      resolve(data);
    });
  });
};

export const deleteDesignById = (designId: string): Promise<any> => {
  return new Promise((resolve) => {
    httpApi.delete("/front/delete-design/" + designId).then(({ data }) => {
      resolve(data);
    });
  });
};

export const getDesignInfoByUniqueId = (designId: string): Promise<any> => {
  return new Promise((resolve) => {
    httpApi.get("/front/get-design-details/" + designId).then(({ data }) => {
      resolve(data);
    });
  });
};
